import React from 'react';
import { APIError } from "system/APIRequest";
import { APIErrorAlert } from 'components/apiHandling/APIErrorAlert';
import { TextLoader } from './TextLoader';

export interface FetchWrapperProps {
  isLoading: boolean;
  fetchError: APIError;
  children?: React.ReactNode;
}

export function FetchWrapper(props: FetchWrapperProps): JSX.Element {
  return (
    <>
      {props.isLoading && 
        <TextLoader /> 
      }
      {props.fetchError && 
        <APIErrorAlert fetchError={props.fetchError} />
      }
      { (!props.isLoading && !props.fetchError) &&
        <>{props.children}</>
      } 
    </>
  );
}